module.exports = __webpack_public_path__ + "static/media/About.5045416f.png";